//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'grid-menu',
    props: {
        cellDatas: Array,
        columnNum: {
            type: Number,
            default: 3
        },
        //是否可删除
        inDelete: Boolean,
        //是否可勾选
        inChoose: Boolean,
    },
    data() {
        return {
            chosens: []
        }
    },
    watch: {
        cellDatas: {
            immediate: true,
            handler(cellDatas) {
                this.chosens = Array.apply(0, new Array(cellDatas.length))
            }
        }
    },
    methods: {
        toDefaultImg(cell) {
            this.$set(cell, 'iconErr', 1)
        }
    }
}
